<template>
  <div class="loading-full-wrap">
    <div class="inner-box">
      <div ref="loadingContainer" class="loading-container">
        <v-progress-circular :size="50" :width="3" color="primary" indeterminate />
      </div>
    </div>
  </div>
</template>
